module.exports = __webpack_public_path__ + "img/Monitoring System Architecture_transparent.2339aa39.svg";